import React from 'react';
import '../styles/theme.css';
import '../styles/Login.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LoginStepRail from '../components/LoginStepRail';
import LoginAccessPanel from '../components/LoginAccessPanel';
/* IMPORTS */

function LoginPage() {
  return (
    <div className="lo-root">
      <div className="lo-layout-1">
        <div id="loginnavbar" className="lo-slot-loginnavbar">
          <Navbar activePage={"Login"} />
        </div>
        <div className="lo-layout-2">
          <div id="loginsteprail" className="lo-slot-loginsteprail">
            <LoginStepRail />
          </div>
          <div id="loginaccesspanel" className="lo-slot-loginaccesspanel">
            <LoginAccessPanel />
          </div>
        </div>
        <div id="loginfooter" className="lo-slot-loginfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
